export default __webpack_public_path__ + "static/media/testimony_teacher_three.1bf5631e.png";